import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './component/LoginScreen/Login';
import Dashboard from './component/Dachboard/AllPages/Dashboard'
import CreateTestingPage from './component/Dachboard/AllPages/CreateTestingPage'
import TestsPage from './component/Dachboard/AllPages/TestsPage';
import GroupsPage from './component/Dachboard/AllPages/GroupsPage';
import ResultsPage from './component/Dachboard/AllPages/ResultsPage';
import TestResultsPage from './component/Dachboard/AllPages/TestResultsPage'; // Новый компонент
import MethodologyPage from './component/Dachboard/AllPages/MethodologyPage';
import CreateGroupPage from './component/Dachboard/CreatePages/CreateGroupPage';
import CreateLink from './component/Dachboard/AllPages/CreateLink';
import { useParams } from 'react-router-dom';
import UserTest from './component/Dachboard/UserRoad/UserTest';
import EditTestPattern from './component/Dachboard/CreatePages/EditTestPattern';
import EditTestPatternPage from './component/Dachboard/AllPages/EditTestPatternPage';
import EditGroupPage from './component/Dachboard/AllPages/EditGroupPage';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/menu1" 
          element={
            <ProtectedRoute>
              <CreateTestingPage />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/testing/:testId/:userId" 
          element={
            <ProtectedRoute>
              <UserTest />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/createlink" 
          element={
            <ProtectedRoute>
              <CreateLink />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/menu2" 
          element={
            <ProtectedRoute>
              <TestsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/menu3" 
          element={
            <ProtectedRoute>
              <GroupsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/edit-group/:id" 
          element={
            <ProtectedRoute>
              <EditGroupPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/edit-test/:id"
          element={
            <ProtectedRoute>
              <EditTestPatternPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/create-group" 
          element={
            <ProtectedRoute>
              <CreateGroupPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/menu4" 
          element={
            <ProtectedRoute>
              <ResultsPage />
            </ProtectedRoute>
          } 
        />
        {/* Новый маршрут для детальной страницы результатов теста */}
        <Route 
          path="/results/:testId"
          element={
            <ProtectedRoute>
              <TestResultsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/menu5" 
          element={
            <ProtectedRoute>
              <MethodologyPage />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;